import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export const DeviceTreeHeader = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <div className="header">
                { t('DEVICES.COLUMN.NAME') }
            </div>
            <div className="header">
                &nbsp;
            </div>
            <div className="header">
                { t('DEVICES.COLUMN.LAST_CHECK_IN') }
            </div>
            <div className="header">
                { t('DEVICES.COLUMN.IP_ADDRESS') }
            </div>
        </Fragment>
    );
};
